module.exports = __webpack_public_path__ + "img/damir.56562a46.jpg";